import ReactTooltip from "react-tooltip";
import Division from "../../../components/Division";
import Header from "../../../components/Header";
import Lateral from "../../../components/Lateral";
import { FaArrowLeft, FaArrowRight, FaCog, FaSearch, FaUser } from "react-icons/fa";
import { useEffect, useState } from "react";
import api from "../../../config";
import { toast } from "react-toastify";
import { convertDateAndHour, getPermission, makeSearch, showMessageError } from "../../../classes/functions";
import Title from "../../../components/Title";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import ReactModal from "react-modal";

export default function Messages(){
    const [list, setList] = useState([]);
    const [listAll, setListAll] = useState([]);
    const [listFinal, setListFinal] = useState([]);

    const [termSearch, setTermSearch] = useState('');

    const [activePage, setActivePage] = useState(0);
    const [totalPage, setTotalPage] = useState(0);

    const [registerFrom, setRegisterFrom] = useState('');
    const [registerTo, setRegisterTo] = useState('');
    const [total, setTotal] = useState('');
    const [itensByPage, setItensByPage] = useState(50);
    const [carrying, setCarrying] = useState(true);

    const [showUserModal, setShowUserModal] = useState(false);

    const [filterUsers, setFilterUsers] = useState([]);
    const [users, setUsers] = useState([]);
    const [searchForFilter, setSearchForFilter] = useState('');
    const [usersId, setUsersId] = useState([]);
    
    useEffect(()=> {
        async function loadMessages(){
          api.get("/api/messages")
            .then((response) => {
              setList(response.data.result);
              setListAll(response.data.result);
              setPagination(response.data.result, itensByPage, termSearch);
              setCarrying(false);
            }
          ).catch((error) => {
            setCarrying(false);
            console.log(error);
            showMessageError(error.response.data);
          });
        }
    
        loadMessages();
    
        return () => {
    
        }
    }, []);

    async function getUsers(){
      await api
            .get('api/users/getList')
            .then((response) => {
              let usersById = [];
              usersId.map((ID) => {
                response.data.map((data) => {
                  if(data.id === ID){
                    usersById.push(data);
                  };
                });
              })
              
              setUsers(usersById);
              setFilterUsers(usersById);
            })
            .catch((error) => {
              console.log(error);
            });
    }

    function search(e) {
      setTermSearch(e.target.value);
      setPagination(listAll, itensByPage, e.target.value);
    }

    function setPagination(aux_list_all = listAll, itensPerPage = itensByPage, auxTermSearch = termSearch) {
      let aux_list_total = [];
    
      aux_list_total = makeSearch(aux_list_all, ['title', 'message'], auxTermSearch);
    
      setTotal(aux_list_total.length);
    
      if (aux_list_total.length > 0) {
        setTotalPage(parseInt(aux_list_total.length / itensPerPage)+1);
        let aux_list = [];
        let final_list = [];
    
        aux_list_total.forEach((element, index) => {
            
        if ((index+1) % itensPerPage === 0) {
          aux_list.push(element);
          final_list.push(aux_list);
          aux_list = [];
        } else {
          aux_list.push(element);
        }
    
        if ((aux_list_total.length === index + 1) && (aux_list !== [])) {
          final_list.push(aux_list);
          aux_list = [];
        }
      });
    
        setList(final_list[0]);
        setListFinal(final_list);
        setRegisterFrom(1);
        setRegisterTo(final_list[0].length);
      } else {
          setList([]);
          setListFinal([]);
          setRegisterFrom(0);
          setRegisterTo(0);
        }
      }

      function nextPage () {
        if ((activePage) <= totalPage-2) {
          setList(listFinal[activePage+1]);
          setActivePage(activePage+1);
    
          setRegisterTo((((activePage+1)*itensByPage)+1) + (itensByPage-1));

          if (((((activePage+1)*itensByPage)+1) + (itensByPage-1)) > total) {
            setRegisterTo(total);
          }
          setRegisterFrom(((activePage+1)*itensByPage)+1);
        }
      }
    
      function lastPage () {
        setList(listFinal[totalPage-1]);
        setActivePage(totalPage-1);
        setRegisterTo(total);
        setRegisterFrom(((totalPage-1)*itensByPage)+1);
      }
    
      function firstPage () {
        setList(listFinal[0]);
        setActivePage(0);
        setRegisterFrom(1);
        setRegisterTo(listFinal[0].length);
      }
    
      function previewPage () {
        if ((activePage-1) >= 0) {
          setList(listFinal[activePage-1]);
          setActivePage(activePage-1);
    
          setRegisterTo((((activePage-1)*itensByPage)+1) + (itensByPage-1));
          if (((((activePage-1)*itensByPage)-1) + (itensByPage-1)) > total) {
            setRegisterTo(total);
          }
          setRegisterFrom(((activePage-1)*itensByPage)+1);
        }
      }

      useEffect(() => {
        getUsers();
      }, [showUserModal]);

      useEffect(() => {
        if(searchForFilter !== ''){
          const lowerSearchForFilter = searchForFilter.toLowerCase();

          setFilterUsers(users.filter((user) => user.nome.toLowerCase().includes(lowerSearchForFilter) || user.perfil.toLowerCase().includes(lowerSearchForFilter) || user.id.toString().toLowerCase().includes(lowerSearchForFilter)));
        } else{
          setFilterUsers(users);
        }
      }, [searchForFilter]);

      const customStyle = {
        content: {
          position: 'fixed',
          left: '20%',
          top: '20%',
          width: '60%',
          height: '70%'
        }
      }

    return (
        <div>
            <Header />
            <Division />
            <Lateral />
            <ReactTooltip />
            <ReactModal 
              isOpen={showUserModal}
              onRequestClose={() => setShowUserModal(false)}
              overlayClassName="modal-overlay"
              style={customStyle}
            >
              <div className="modal-header">
                <h2>Usuários</h2>
                <div>
                  <input className="modal-header__input" type="text" value={searchForFilter} onChange={(e) => setSearchForFilter(e.target.value)} placeholder="Pesquisar..." />
                  <button className="modal-header__button" onClick={() =>  setShowUserModal(false)}>Fechar</button>
                </div>
              </div>
              <table className="users">
                <thead className="users__header">
                  <tr>
                    <td>Nome</td>
                    <td>Perfil</td>
                    <td>Id</td>
                  </tr>
                </thead>
                <tbody className="users__body">
                  {filterUsers.map((user, index) => {
                    return (
                      <tr className="" key={index}>
                        <td className="user__title">{user.nome}</td>
                        <td className="user__title">{user.perfil}</td>
                        <td className="user__title">{user.id}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </ReactModal>

            {carrying && <div className="content">
                <div className="divCarrying">
                    <span>Carregando...</span>
                    <FaCog icon="spinner" className="spinner" />
                    </div>
                </div>
            }
            {!carrying && <div className="content">
                <Title name="Mensagens">
                  {getPermission('CADASTROS - MENSAGENS - CADASTRO') && <Link to="/messages/cadastrar">
                      <button style={{width: '10%'}} className="buttonInsert">
                        Nova Mensagem
                      </button> 
                  </Link>}
                  <select className='selectQtdeItens' value={itensByPage} onChange={ (e) => {setItensByPage(e.target.value);setPagination(listAll, e.target.value);} }>
                      <option value="50">Itens por página</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                      <option value="40">40</option>
                      <option value="50">50</option>
                  </select>
                  <input className="inputSearch" type="text" onChange={search} placeholder="Pesquisar"/>
                  <FaSearch className="iconSearch" style={{color: '#001675' }} size={16}/>
                </Title>

                <div className="container">
                <table>
                    <thead>
                        <tr>
                            <th scope="col">Título</th>
                            <th scope="col">Mensagem</th>
                            <th scope="col">Data/Horário</th>
                            <th scope="col">Usuário</th>
                        </tr>
                    </thead>
                    <tbody>
                    {list.map((item, index)=>{
                        return(
                        <tr key={index}>
                            <td data-label="Título">{item.title}</td>
                            <td data-label="Mensagem" id="mensagem">{item.message}</td>
                            <td data-label="Data" id="data">{convertDateAndHour(item.created_at)}</td>
                            <td data-label="Usuário">
                                <FaUser onClick={() => {
                                    setUsersId(item.to)
                                    setShowUserModal(true)
                                  }} /> 
                            </td>
                        </tr>
                        )
                    })}
                    {list.length === 0 && <tr>
                        <td colSpan={2}><label className='required'>Nenhum registro encontrado!</label></td>
                    </tr>}
                    </tbody>
                </table>
                </div>
                <br/>
                <div className="divGroupPagination">
                    <button data-tip="Primeira página" type="button" onClick={firstPage} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft  color="#001675" size={17} /></button>
                    <button data-tip="Página anterior" type="button" onClick={previewPage} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
                    <div className="divLabelPagination">
                    <center><label className="labelPage">Exibindo {registerFrom} a {registerTo} de {total} registros</label></center>
                    </div>
                    <button data-tip="Próxima página" type="button" onClick={nextPage} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
                    <button data-tip="Última página" type="button" onClick={lastPage} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight  color="#001675" size={17} /></button>
                </div>
            </div>}
            </div>
    )
}